import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface CentriDiCostoState {
  form: any[];
}

export function createInitialState(): CentriDiCostoState {
  return {
    form: null
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'centriDiCosto' })
export class CentriDiCostoStore extends Store<CentriDiCostoState> {
  constructor() {
    super(createInitialState());
  }

  setForm(data) {
    this.update({ form: data });
  }
  resetForm() {
    this.update(createInitialState());
  }
  reset() {
    this.update(createInitialState());
  }
}
